import { useMemo } from 'react';

import type { IGameLayoutLabels } from '@skillarea/game-layout';
import { useTranslation } from 'react-i18next';

export function useGameLayoutLabels(): IGameLayoutLabels {
  const { t } = useTranslation('matchmaking');

  return useMemo(
    () => ({
      giveUp: t('game.giveUp'),
      mute: t('game.mute'),
      unmute: t('game.unmute'),
      howToPlay: t('game.howToPlay'),
      rulesTitle: (gameName: string) => t('game.rulesTitle', { gameName }),
      gotIt: t('game.gotIt'),
      surrenderDialog: {
        title: t('game.surrender.title'),
        description: t('game.surrender.description'),
        keepPlaying: t('game.surrender.keepPlaying'),
        surrender: t('game.surrender.confirm'),
      },
    }),
    [t],
  );
}
